export enum AppMenuGroup {
	BENUTZERPROFIL = "benutzerprofil",
	MAIN = "hauptmenu",
	EINSTELLUNGEN = "einstellungen"
}
